import React from "react";
import FlightList from './FlightList';
import Next from './Next';
import packageJson from '../package.json';
import axios from 'axios';



export default class flights extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      ...props,
      launches: [],
      go: false,
      flightData:{
        flight: false
      }
    };
  }

  getLaunches = async () => {
    try{
      console.log(packageJson.URL, "ciao!")
      const response = await axios
        .get(packageJson.URL + '/launches/')
        .then((response)=>{
          console.log(response, "response");
          this.setState({
            launches: response.data.launches,
            go: true
          }, () => {
            let top = document.getElementById("flights").getBoundingClientRect().top + window.scrollY
            window.scrollTo({
              top: top - 60,
              left: 0,
              behavior: 'smooth'
            });
          })
        })
        .catch(err =>{
          console.log(err, "err" )
        })
    }catch(error) {
      return [];
    }
  }

  componentDidMount() {
    this.getLaunches();
  }


  next = () => {
    this.cb({field: 'flightReady', value: true})
  }


  cb = (params) => {
    const n = { [params.field]: params.value };
    this.setState({flightData: {...this.state.flightData, ...n}});
    this.props.callback(params);
  }


  render() {
    let readyClass = this.props.flightData.flightReady ? 'ready' : 'notready';
    return (
      <div id="flights">
        {(!this.state.go)?
          (
            <div className="p-5 mb-4 bg-light rounded-3">
              <div className="container-fluid">
                <div className="text-center">
                  <div className="spinner-border text-primary mx-auto" role="status">
                    <span className="visually-hidden">Loading...</span>
                  </div>
                </div>
              </div>
            </div>
          )
          :
          (<>
            {(this.state.launches.length>0)?
              (
                <>
                  <div className="results">
                    <div className={readyClass}>
                      <FlightList
                        flights={this.state.launches}
                        formData={this.state.formData}
                        callback={this.cb}
                      />
                    </div>
                  </div>
                  {((this.props.flightData.flight)&&(!this.props.flightData.flightReady))&&
                    <Next callback={this.next} />
                  }
                </>
              )
              :
              (<div>(E101) The system was not able to find a match for your mission requirements. <a href="mailto:sales@dorbit.space">Get in touch with us</a> to find a solution that can suit you!</div>)
            }
          </>)
        }
      </div>
    );
  }
}
